import React from 'react';
import { connect } from 'react-redux';

import { setOptions } from 'src/reducers/selectOptions';
import EditCustomFeatureContainer from './Components/EditCustomFeatureContainer';

export const EditCustomFeature = ({ values, dispatch, match }) => {
  dispatch(
    setOptions({
      ...values.extraAttr
    })
  );

  return (
    <div className="l-wrap-xl">
      <h2 style={{ marginBottom: '2rem' }}>Edit feature</h2>
      <EditCustomFeatureContainer values={values.clientCustomFeature} params={match.params} />
    </div>
  );
};

export default connect()(EditCustomFeature);
